import enLocal from 'vant/lib/locale/lang/en-US'
import ruJame from './languageJame/ru'
import ruGaea from './languageGaea/ru'
const ru = {
  300000: '新年送礼',
  300001: '2022新年送礼',
  300002: 'SuperEx和你一起过新年',
  300003: '尊敬的SuperEx用户：<br>为庆祝SuperEx在新年之际盛大上线,<br>平台将随机空投送出价值1,000,000 USDT新年大礼包。 <br>具体活动如下：',
  300004: '活动时间<br>加拿大时间：2022年01月01日00：00-02月15日23：59',
  300005: '活动一：分享海报获空投',
  300006: '分享活动海报至＞1000人的telegram加密货币群组，并附言“百万豪礼大派送，SuperEx和你一起过新年！或分享活动海报至个人Tiwwer，置顶并附言“百万豪礼大派送，SuperEx和你一起过新年！ ”上传截图给客服，将有机会获得5 ET（价值5 USDT）。',
  300007: '活动二：邀新获VIP',
  300008: '获得期间，用户通过邀请好友新注册并成功入金≥100 USDT即为有效邀请人数。成功邀请人数越多，所获VIP等级越高。有效期（30天）',
  300009: '活动三：新用户充值送',
  300010: '活动期间，新注册用户净充值金额达到一下区间并完成一笔交易，即可获得ET奖励。 （净充值金额在活动结束前以USDT结算）活动期间，新注册用户净充值金额达到一下区间并完成一笔交易，即可获得ET奖励。 （净充值金额在活动结束前以USDT结算）',
  300011: '注意事项：',
  300012: '1.每位参与用户只能获得一次奖励 <br>2.所有参与用户默认遵守SuperEx服务条款，如发现违规将立即停止其活动资格 <br>3.SuperEx有权在不提早通知用户的情况下修改本次活动的条款 <br>4.SuperEx将取消不合规用户活动参与资格并停用相关SuperEx账户使用 <br>5.SuperEx保留本次活动最终解释权',
  300013: '立即分享',
  300014: 'SuperEx团队',
  300015: '2022年01月01日',
  300016: '更多信息关注SuperEx官网：SuperEx.com',
  300017: '净充值金额（{coin}）',
  300018: '奖励金（{coin}）',
  300019: '180天',
  300020: '净充值=总入金金额-总出金金额',
  300021: 'ET持仓数量',
  300022: 'Maker/Taker',
  300023: '有效邀请人数',
  300024: '赠送有效期',
  300025: '活动获取条件',
  300026: '注：所有赠送的VIP等级均无需ET持仓要求。 ',
  300027: 'Копирование успешно',
  300028: 'Копия не удалась',

  300029: 'Скачать приложение SuperEx',
  300030: 'Торгуйте в любое время и в любом месте',
  300031: 'Создать учетную запись SuperEx',
  300032: '若您已有SuperEx账户，请先登录',
  300033: 'Электронная почта',
  300034: 'Телефон',
  300035: 'Мобильный телефон',
  300036: 'Пароль',
  300037: 'Реферальный ID(Опционально)',
  300038: 'Я прочитал и согласен',
  300039: 'Условия обслуживания SuperEx',
  300040: 'Мне больше 18 ле, и я согласен с Условиями SuperEx',
  300041: 'Регистрация',
  300042: 'Проверка безопастности ',
  300043: 'Выберите код области',
  300044: 'Поиск монеты',
  300045: 'Пожалуйста, введите свой номер мобильного телефона',
  300046: 'Пожалуйста, введи правильный номер телефона',
  300047: 'Пожалуйста, введите свой адрес электронной почты',
  300048: 'Пожалуйста, введите правильный адрес электронной почты',
  300049: 'Пожалуйста, введите свой пароль',
  300050: 'Не менее 8 символов, включая заглавные буквы и цифры',
  300051: 'Код верификации с почты',
  300052: 'Мобильный код подтверждения',
  300053: 'Google/Microsoft Auth',
  300054: 'Google/Microsoft Authenticator',
  300055: 'В целях безопасности вашей учетной записи выполните следующие операции проверки',
  300056: 'Подать',
  300057: '6-значный код будет отправлен на {phone}',
  300058: 'Код будет отправлен на {email}',
  300059: 'Пожалуйста, введите 6-значный проверочный код SuperEx/Google/Microsoft',
  300060: 'Введите 6-значный код проверки',
  300061: 'Отправить код',
  300062: '{timeout}s',
  300063: 'Язык',
  300064: 'На рассмотрении',
  300065: 'Введите английские буквы или обычные знаки препинания',


  300066: 'Центр задач',
  300067: 'Рейтинг скидок сражений',
  300068: 'Получите до <em class="bold normal" style="font-size: 1.2rem;color: #FFC72B;">1BTC</em>!',
  300069: 'Приглашать',
  300070: 'Таблица лидеров',
  300071: 'Правила разблокировки',
  300072: 'Выполните задание, чтоыб получить награду',
  300073: 'Рейтинг скидок сражений. До 1 BTC ждет вас!',
  300074: 'Завершите транзакцию, чтобы разблокировать ET',
  300075: 'Завершите все вышеупомянутые задачи, чтобы получить whitelsit, и SuperEx случайным образом будет раздавать большое количество токенов ET для пользователей whitelsit\'а.',
  300076: 'Ежедневный рейтинг',
  300077: 'Общий рейтинг',
  300078: 'Условия обслуживания',
  300079: 'Мои награды',

  300080: 'Заблокированная сумма',
  300081: 'Разблокировать сумму',
  300082: 'Разблокировать сумму = торговая комиссия * разблокированная сложности / ET цена',
  300083: 'Торговать',
  300084: 'Рейтинг',
  300085: 'Аккаунт',
  300086: 'Комиссия',
  300087: 'Примечание. Ежедневный рейтинг рассчитывается до 0:00 дня (UTC-4), и на следующий день будут выданы награды. Могут быть ошибки в данных только для справки.',
  300088: 'Примечание. Вознаграждение будет внесено в течение 3 рабочих дней после завершения события, и данные могут иметь ошибки только для справки.',
  300089: 'Просмотреть больше',

  300090: 'Закрывать',
  300091: 'Вы уже пользователь whitelisted!',
  300092: 'Введите свою учетную запись {type}',
  300093: 'Заключительный этап',
  300094: 'Следите за нами в Twitter',
  300095: 'Присоединяйтесь к нашей официальной Telegram Group',
  300096: 'Внести начальный депозит',
  300097: 'Провести спотовую сделку',
  300098: 'Провести фьючерсную сделку',
  300099: 'Пригласить друга для регистрации',

  300100: 'Пригласить друга для торговли',
  300101: 'Порекомендовать другу торговать больше',
  300102: 'Депозит',
  300103: 'Подписаться',
  300104: 'Получить',
  300105: 'Собрано (раз)',
  300106: 'Еще не открыт',
  300107: 'Присоединиться',
  300108: 'Записей не найдено',
  300109: 'Выполнено',
  300110: 'Отличные новости! получите бесплатные награды и пригласите друзей, чтобы насладиться большим количеством преимуществ.',
  300111: 'Отмена',
  300112: 'Подать',
  300113: 'Не отправляйте повторно',
  300114: 'В настоящее время нет задач',
  300115: 'Следите за новостями',
  300116: 'Следите за новостями!',
  300117: 'Пожалуйста, введите свою учетную запись',
  300118: 'Пожалуйста, введите свою учетную запись',
  300119: 'Отклонен',
  300120: 'Мгновенная регистрация на SuperEx',
  300121: 'Регистрация',
  300122: 'Истекший',
  300123: 'Белая книга',

  300124: 'Загадочная коробка',
  300125: 'Получите награду в размере 1 000 USDT в Crypto Mystery Box со <em class="normal bold" style="color: #FFC72B">100%</em>-ным процентом выигрышей',
  300126: 'Правила',

  300127: 'Открыть загадочную коробку',
  300128: 'Количество розыгрышей',
  300129: 'Остаток (мой)',
  300130: 'Открыто (Всего USDT)',
  300131: 'Вознаграждения',
  300132: 'Как принять участие?',
  300133: 'Поделитесь своей пригласительной ссылкой',
  300134: 'Выполняйте задания',
  300135: 'Пригласите друзей зарегистрироваться и выполнить транзакционные задачи',
  300136: 'Получите загадочную коробку',

  300137: 'Выполните задания и получите загадочную коробку',
  300138: 'Это событие закончилось, ждите следующего события!',
  300139: 'Это событие еще не началось, следите за новостями!',
  300140: 'Правила события',
  300141: 'OK',
  300142: 'Время',
  300143: '',
  300144: '',
  300145: 'Пригласите друзей',
  300146: 'Зажигайте фонари и веселитесь на <em class="normal" style="color: #FFC72B">Хэллоуин</em>',
  300147: 'Войдите в аккаунт в течение <em class="normal" style="color: #FFC72B">{num}</em> дней подряд и получите шанс выиграть приз <em class="normal" style="color: #FFC72B">{amount} ET</em>',
  300148: 'Список победителей',
  300149: 'Ежедневный вход',

  300150: 'Вы вошли в систему {num} дней',
  300151: 'Розыгрыш призов',
  300152: 'Вошел',
  300153: 'Войти',
  300154: '',
  300155: '',
  300156: 'Войти',
  300157: 'Получили купон на скидку по фьючерсной комиссии!',
  300158: 'Успешное повышение статуса VIP!',
  300159: 'Получите возможность выиграть в лотерею!',

  300160: 'Купон на фьючерсную комиссию',
  300161: 'VIP-улучшение',
  300162: '',
  300163: 'У вас есть <em class="normal" style="color: #FFC72B">{num}</em> возможностей для повторного выхода',
  300164: 'Получите возможность войти',
  300165: 'Можно повторно войти',
  300166: 'Советы',
  300167: 'Повторный вход успешно выполнен',
  300168: 'У вас еще нет нужного количества входов в систему, вы можете получить один повторный вход за депозит в размере ≥{num} {symbol} в тот же день.',
  300169: 'Войти',

  300170: 'Вы достигли лимита повторного входа',
  300171: 'Список победителей, которые вошли в систему в течение 7 дней подряд',
  300172: 'Войдите в систему постоянно, чтобы получить следующие награды',
  300173: 'Заявлено',
  300174: '{num} дни',
  300175: 'Купон на фьючерсную комиссию',
  300176: 'Мой VIP уровень',
  300177: 'Участвовать в лотерее',
  300178: 'Поздравляем!',
  300179: 'Вы успешно вошли',
  300180: '',
  300181: 'Академия',
  300182: 'Новости',
  300183: 'Дата',
  300184: 'Изучение',
  300185: 'Получите подробный обзор основных событий в мировой криптоиндустрии',
  300186: 'Получите краткий обзор последних событий в криптоиндустрии по всему миру',
  300187: 'Узнайте все о блокчейне, Web3 и криптовалюте',
  300188: 'Читать дальше',
  300189: 'Видео',
  300190: 'Загрузка',
  300191: 'Все загружено',
  300192: 'Все',
  300193: 'Турнир не начался',
  300194: 'Выбери победителя чемпионата мира по футболу и получи <em class="normal" style="color:#DBFF00">Бонус</em>',
  300195: 'Время события',
  300196: 'Запись голосования',
  300197: 'Групповой этап',
  300198: 'Группа {num}',
  300199: 'Призовой пул: {num}',
  300200: 'Поддержка',
  300201: 'Этап элиминации',
  300202: 'Соревнования',
  300203: 'Срок голосования',
  300204: 'Голосование',
  300205: 'Пожалуйста, введите количество голосов',
  300206: 'Минимальное количество ставок: {num} ET ',
  300207: 'Время прогноза',
  300208: 'Ставки на команды',
  300209: 'Голоса',
  300210: 'Сумма приза',
  300211: 'Квалифицированные команды',
  300212: 'День',
  300213: 'Час',
  300214: 'Мин',
  300215: 'Сек',
  300216: 'Матчи',
  300217: 'Событие еще не началось',
  300218: '1/4 Финал',
  300219: 'Подтвердить',
  300220: 'Количество голосов',
  300221: 'Недостаточный баланс',
  300222: 'Депозит',
  300223: 'Прогноз успешен',
  300224: '1/8 Финал',
  300225: 'Полуфинал',
  300226: 'Финалисты третьего и четвертого мест',
  300227: 'Финал',
  300228: 'Победа',
  300229: 'Потеря',
  300230: 'Общий призовой фонд:{num} ET',
  300231: 'Посмотреть больше матчей',
  300232: 'Другие соревнования',
  300233: 'Валюта',
  300234: 'Рыночная цена',
  300235: '24ч Изм%',
  300236: 'Новое руководство пользователя',
  300237: 'Начните изучать торговлю цифровой валютой прямо сейчас',
  300238: 'Глобальное присутствие',
  300239: 'Безграничность, децентрализация сообщества и автономия, децентрализация команды является окончательной формой развития Superex',

  300240: 'Нулевой риск безопасности',
  300241: 'Децентрализованный кошелек интегрирован, а закрытый ключ зашифруется и сохранится на пользовательском устройстве. Не зависит от безопасность кода, политики и других факторов',
  300242: 'Нет регистрации и KYC ',
  300243: 'Авторизованные транзакции кошелька, без регистрации, без KYC, расчеты по транзакциям выполняются в сети, не могут быть подделаны, безопасны и прозрачны',
  300244: 'Открытая система ',
  300245: 'Пользователям разрешено взаимодействовать с Dapps и смарт-контрактами. Открыв SuperWallet, пользователи могут быть авторизованы для участия в Meta, DeFi и NFT.',
  300246: 'Космический фонд',
  300247: 'Космический фонд используется для исследования космоса людьми или для финансирования учреждений или отдельных лиц, которые внесли значительный вклад в исследование космоса людьми',
  300248: 'Безопасный и простой в использовании обмен',
  300249: 'Загрузите мобильное приложение Superex, чтобы следить за рынками и совершать сделки в идеальный момент, где бы вы ни находились.',

  300250: 'Больше загрузок',
  300251: 'Каждая сделка, которую вы совершаете, является топливом для людей, чтобы летать в космос',
  300252: 'Зарегестрироваться сейчас',
  300253: 'Отсканируйте для загрузки на <br> iOS и Android ',
  300254: 'Аутентификатор',
  300255: 'Аутентификатор сгенерирует для вас код двухэтапной проверки. Ваш аккаунт SuperEx станет еще более безопасным с двухэтапной верификацией.',
  300256: 'Аутентификатор SuperEx',
  300257: 'Google Auth',
  300258: 'Microsoft Auth',
  300259: 'Скачайте клиент (iPhone)',

  300260: 'Скачайте клиент (Android)',
  300261: 'Самая безопасная платформа для торговли цифровыми активами в мире！',
  300262: 'О нас',
  300263: 'Условия',
  300264: 'Конфиденциальность',
  300265: 'Объявления',
  300266: 'Академия',
  300267: 'Центр новичков',
  300268: 'Спотовая сделка',
  300269: 'Фьючерсы',

  300270: 'FAQ',
  300271: 'Обслуживание',
  300272: 'Сборы',
  300273: 'Правила',
  300274: 'Листинговая заявка',
  300275: 'Реферал',
  300276: 'Связаться с нами',
  300277: 'Центр поддержки',
  300278: 'Отправить запрос',
  300279: 'Бизнес контакты',

  300280: 'Институциональное сотрудничество',
  300281: 'Больше',
  300282: 'С возвращением!',
  300283: 'Забыли пароль?',
  300284: 'У вас еще нет аккаунта?',
  300285: 'Перейдите к APP или компьютеру для восстановления пароля',
  300286: 'Хорошо',

  300287: 'Подтвердить',
  300288: 'Будет объявлено',
  300289: 'Необходимо заявить',

  300290: 'Уже присоединился',
  300291: 'Уже возмещено',
  300292: 'Правила покупки',
  300293: "Покупайте <span style='color: #ffc72b;'>товары</span>",
  300294: 'Выберите и купите',
  300295: 'Ожидание результатов',
  300296: 'Оформить заявку на товар',
  300297: 'Депозит',
  300298: 'Запись на покупок',
  300299: 'Список товаров',
  300300: 'Единовременный платеж за участие',
  300301: '{num} копий было продано. Товар будет продан по достижении {pirce} {currency}.',
  300302: 'Присоединиться сейчас',
  300303: 'Присоединиться снова',
  300304: 'Выберите количество покупок',
  300305: "1 штука стоит <span style='color: #fa4d56;'>{minPrice} {currency}</span>, а за один товар можно приобрести не более <span style='color: #fa4d56;'>{maxBuyCount} копий</span>",
  300306: 'штук',
  300307: 'У вас есть {num} {currency}, чем больше копий вы купите, тем выше шанс выиграть!',
  300308: 'Купить',
  300309: 'Следующий раз',
  // 300309: '余额充值',
  300310: 'Поздравляем!',
  300311: 'Получить',
  300312: 'Попробуйте еще раз!',
  300313: 'Завершите криптовалютный или P2P-депозит на APP.',
  // 300314: '我知道了',
  300315: 'Свяжитесь со службой поддержки в приложении, чтобы получить товар.',
  // 300316: '我知道了',
  300317: 'Вход / Регистрация',
  300318: 'Стоимость {num} {currency}',
  300319: 'Описание товара',
  300320: 'Мое участие',
  300321: 'Время',
  300322: 'Участвующие товары',
  300323: 'Количество приобретенных единиц',
  300324: 'Сумма возврата',
  300325: 'Операция',
  300326: 'Получить',
  300327: 'У вас уже есть аккаунт?',
  300328: 'Войдите',
  300329: 'Код идентификации ',
  300330: 'Отображаются только записи за последние семь дней',
  300331:'Аутентификатор',
  300332:'Загрузить',
  300333:'1 USDT может купить 1 Bitcoin',
  300334:"Цена покупки",
  300335:"Предыдущие результаты",
  300336:"期次",
  300337:"Просмотр правил",
  300338:"Выпуск: [Фаза {num}]",
  300339:"Процесс покупки",
  300340:" Успешно купившие пользователей",
  300341:"Время объявления",
  300342:"Поделиться",
  300343:"Выпуск [{num}]",
  300345:"Загрузить",
  300346:"Поделитесь своей радостью",
  300347:"Сканируйте код для присоединения",
  300348:"Оформить заявку на товар",
  300349:"Примечание: Товары в цифровой валюте будут отправлены на ваш аккаунт в течение 48 часов.",
  300350:"Для получения других товаров обратитесь в службу поддержки клиентов",
  300351:"Перейти к просмотру",
  300352:"Зарегистрироваться сейчас",
  300353:"Зарегистрировано",
  300354:'Регистрация закрыта',
  300355:'Регистрация прошла успешно',
  300356:'открыть приложение',
  300357:'Поздравляем {user} с приобретением {shop}!',
  300358:'Центр событий',
  300359:'В процессе',
  300360:'Скоро начнется',
  300361:'Завершено',
  300362:'Присоединяйтесь сейчас',
  300363: 'Завершено',
  300364: 'Победители',
  300365: 'Победители будут объявлены в ближайшее время',


  310000:'Обзор наград',
  310001:'SCS Аирдроп',
  300366: 'Валюта',
  300367: 'Продать',
  200368: 'Платить',
  300369: 'Получить',
  300370: 'Получить',
  300371: 'Лимит на одну транзакцию:',
  300372: 'Способ оплаты',
  300373: 'Способ оплаты',
  300374: 'Поставщик платежа',
  300375: 'Реквизиты заказа',
  300376: 'Сумма (включая комиссию за транзакцию)',
  300377: 'Время прибытия',
  300378: 'Отказ от ответственности',
  300379: 'Я прочитал и согласен с дисклеймером',
  300380: "Вы покидаете SuperEx и переходите на <span>{name}</span>, лицензированное финансовое учреждение, предоставляющее возможности оплаты картами в качестве третьей стороны. Все риски, возникающие в процессе использования, несет <span>{name}</span>. Пожалуйста, прочитайте и согласитесь с <a class= 'pointer'  href={server}>Соглашением об обслуживании</a> компании <span>{name}</span>, прежде чем воспользоваться ее услугами.Если у Вас возникли вопросы по поводу пополнения счета кредитной картой, пожалуйста, свяжитесь с <a class='pointer'  href={Customer}>{name} Customer Service</a> для получения более подробной информации.",
  300381: 'Как купить криптовалюту на SuperEx?',
  300382: 'Как продать криптовалюту на SuperEx?',
  300383: 'Разместить заказ на покупку криптовалюты',
  300384: 'Выберите фиатную валюту, которой вы хотите расплатиться, и криптовалюту, которую вы хотите купить. Введите сумму, которую вы хотите потратить.',
  300385: 'Верифицируйте свою личность',
  300386: 'Пройдите KYC-верификацию на SuperEx и у платежного провайдера, чтобы завершить платеж.',
  300387: 'Проверьте детали заказа',
  300388: 'Проверьте историю пополнения счета, чтобы узнать статус заказа.',
  300389: 'FAQ',
  300390: '1. Какие способы оплаты я могу использовать для покупки криптовалюты?',
  300391: 'В настоящее время SuperEx поддерживает платежные системы VISA, Mastercard, Apple Pay, Google Pay и другие способы оплаты. Среди поддерживаемых сторонних поставщиков услуг - Mercuryo и alchemypay.',
  300392: '2. Какие криптовалюты я могу приобрести?',
  300393: 'SuperEx поддерживает основные криптовалюты, такие как BTC, ETH, USDT, LTC, USDC, XRP, BCH, CRV и TRX.',
  300394: '3. Контролирует ли SuperEx качество и цены поддерживаемых сторонних поставщиков услуг?',
  300395: 'SuperEx тщательно отобрал ряд поставщиков услуг с надежной репутацией в отрасли, популярностью и безопасностью, чтобы обеспечить пользователей удобными услугами.',
  300396: '4. Какую комиссию я должен заплатить за покупку криптовалюты?',
  300397: 'Вы платите комиссию стороннему поставщику услуг и комиссию за перевод на цепочку. SuperEx не взимает никаких комиссий.',
  300398: '5. Сколько времени занимает получение криптовалюты после оплаты?',
  300399: 'После завершения платежа на платформе стороннего поставщика услуг криптовалюта будет зачислена на ваш спот-счет на SuperEx примерно через 2-10 минут.',
  300400: '6. Что делать, если у меня возникнут проблемы в процессе покупки?',
  300401: 'Обратитесь в службу поддержки, если у вас возникнут какие-либо проблемы в процессе транзакции. Если вы не получили криптовалюту после завершения платежа, свяжитесь со сторонним поставщиком услуг для проверки деталей заказа (обычно это наиболее эффективный метод). В связи с IP вашего текущего региона или по определенным политическим причинам вам придется выбрать верификацию человеком.',
  300402: "Доступно",
  300403: 'Недостаточный баланс',
  300404: 'Please enter currency',
  300405: 'Введите фиатную валюту',
  300406: 'Вы не завершили верификацию личности',
  300407: "В целях безопасности вашего аккаунта и других торговых пользователей, сначала пройдите верификацию личности",
  300408: 'Неподтверждённый ',
  300409: 'Неверифицирован',
  300410: 'Выберите Валюту',
  300411: 'Выберите фиатную валюту',
  300412: 'All currencies',
  300413: 'Все фиатные валюты',
  300414: '≈{time} минут',
  300415: 'Торговля P2P не открыта для авторизованных пользователей кошелька в настоящее время, пожалуйста, используйте свой аккаунт SuperEx для входа и торговли P2P',
  300416: 'https://support.superex.com/hc/en-001/articles/23084120565017',
  300417:'Купить',
  300418: 'Серийный номер',
  300419: 'SuperEx Карнавал на Хэллоуин',
  300420: 'Входите в систему, получайте подарки и торгуйте, чтобы выиграть бонусы!',
  300421:'Тип',
  300422:'Криптовалютные награды',
  300423:'',
  300424:'',

  400000:'Первая криптовалютная биржа Web3',
  400001:'Присоединяйтесь к нам и создайте финансовый мир',
  400002:'Каждая сделка, которую вы совершаете, является топливом для людей, чтобы летать в космос !',
  400003:'Захватывающий обзор SuperEX',
  400004:'Активное участие и общие улыбки: История нашей стены активности',
  400005:'Выбрать язык и регион',
  400006:'0 РИСК',
  400007:'БЕЗ KYC',
  400008:'ОТКРЫТО',
  400009:'ФОНД',
  400010:'Mainnet Explorer',
  400011:'Testnet Explorer',
  400012:'Документы для разработчиков',
  400013:'Другой',
  400014:'Зона ET',
  400015:'',

  ...enLocal,
  ...ruJame,
  ...ruGaea
}
export default ru;



// WEBPACK FOOTER //
// ./src/i18n/langs/ru.js